import api from 'src/services/api'
import { UserEndpoints } from './constants'
import {
  GetUserDataByUcodeParams,
  GetUserDataByUcodeResponse,
  GetUserPostsByUcodeParams,
  GetUserSessionDataParams,
  GetUserSessionDataResponse
} from './types'

export const getUserDataByUcode = async ({
  ucode,
  avatarDimensions
}: GetUserDataByUcodeParams): Promise<GetUserDataByUcodeResponse> => {
  const url = UserEndpoints.getUserDataByUcode(ucode)

  const res = await api.get(url, {
    params: {
      avatarDimensions
    }
  })

  return res.data
}

export const getUserPostsByUcode = async ({
  ucode,
  rows,
  pageToken
}: GetUserPostsByUcodeParams) => {
  const url = UserEndpoints.getUserPostsByUcode(ucode)

  const res = await api.get(url, {
    params: {
      rows,
      pageToken
    }
  })

  return res.data
}

export const getUserSessionData = async ({
  token,
  membership
}: GetUserSessionDataParams): Promise<GetUserSessionDataResponse> => {
  const url = UserEndpoints.getUserSessionData()
  const res = await api.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
      slug: membership
    }
  })

  return res.data
}
